import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import { Routes } from ".";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
interface NotStarted {
  status: string;
  qtd: string;
}

export const ChartPie = ({ data }: Routes) => {
  const { getSizesComponent, componentProperty } =
    useContext(DashboardContext);
  const [dataChart, setDataChart] = useState<{delayed: string, on_time: string}>({delayed: '0', on_time: '0'});
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [widthChart, setWidthChart] = useState(300);
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    let c_total = 0;
    data.collects.forEach((route: NotStarted) => {
      c_total = +c_total + +route.qtd;
    });
    setTotal(c_total);
    setDataChart({
      delayed: data?.collects.find((objeto: NotStarted) => objeto.status === 'Atrasada')?.qtd || '0',
      on_time: data?.collects.find((objeto: NotStarted) => objeto.status === 'No Horário')?.qtd || '0',
    });
  }, [data]);

  const getPositionLegend = (width: number, height: number): 'right' | 'bottom' => {
    if (width < 250 || height / width > 1.5) {
      return "bottom"
    } else {
      return "right";
    }
  };

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "pie",
    },
    stroke: {
      colors: undefined,
    },
    labels: ["Atrasada", "No Horário"],
    colors: ["#FFC125", "#01b8aa"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend:{
      position: getPositionLegend(widthChart, heightChart)
    },
  };

  const series = [parseInt(dataChart.delayed), parseInt(dataChart.on_time)];

  useEffect(() => {
    const sizes = getSizesComponent({
      id: "chart-general-not-started-collects-documents",
    });
    if(sizes.width < 250){
      setHeightChart(sizes.height-30);
    }else{
      setHeightChart(sizes.height-(0.20*sizes.height));
    }
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100 component-height">
      <HeaderComponent
        title={`Não iniciadas - atrasos: Existem ${total} rotas com coletas não iniciadas`}
        clickable={componentProperty({
          id: "chartGeneralNotStartedCollectsDocuments",
          property: "redirect",
        })}
        id="chart-general-not-started-collects-documents"
      />
      <div id="chart" className="component-content">
        <Chart
          type="pie"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
